import axios from '../requester';
import { API, LINB_API } from '../constants/api-urls';
import moment from 'moment';

export const getAvailability = async ({ sensor_authorization_id }) => {
  return await axios.get(
    `${urlV2(
      LINB_API.RESOURCE_ALLOCATION.AVAILABILITY
    )}?sensor_authorization_id=${sensor_authorization_id}`
  );
};

export const getAggregatedTable = async ({
  sensor_authorization_id,
  before,
  after,
  type, // enum: project|epic
  issue_type,
  extraParams,
  filtersPayload,
  limit,
  offset,
  sort_by,
  sort_dir,
  keyword = '',
  extraPayload = {}
}) => {
  return await axios.post(
    urlV2(LINB_API.RESOURCE_ALLOCATION.WIDGETS.AGGREGATED_TABLE),
    {
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      ...(type && { type }),
      ...(issue_type && { issue_type }),
      limit,
      offset,
      ...(sort_by ? { sort_by } : {}),
      ...(sort_dir ? { sort_dir } : {}),
      ...(keyword.length > 0 ? { keyword } : {}),
      configure: {
        ...(extraParams && { ...extraParams })
      },
      ...(filtersPayload && { ...filtersPayload }),
      ...(extraPayload && { ...extraPayload })
    }
  );
};

const formatDate = d => moment(d).format('YYYY-MM-DD');
const urlV2 = url =>
  url.replace('pm/resource-allocation', 'pm/pm-projects/resource-allocation');

export const getInvestmentCarving = async ({
  sensor_authorization_id,
  before,
  after,
  filtersPayload,
  extraPayload = {}
}) => {
  return await axios.post(API.INVESTMENT_CARVING_V2, {
    sensor_authorization_id,
    before: formatDate(before),
    after: formatDate(after),
    ...(filtersPayload && { ...filtersPayload }),
    ...(extraPayload && { ...extraPayload })
  });
};

export const getSummary = async ({
  sensor_authorization_id,
  before,
  after,
  filtersPayload,
  extraPayload = {}
}) => {
  return await axios.post(
    urlV2(LINB_API.RESOURCE_ALLOCATION.WIDGETS.SUMMARY_HEADER),
    {
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      ...(filtersPayload && { ...filtersPayload }),
      ...(extraPayload && { ...extraPayload })
    }
  );
};

export const getOverTimeChart = async ({
  sensor_authorization_id,
  before,
  after,
  type, // project | epic | issue_type | initiative || custom_field
  issue_type,
  aggregation_ranges, // month | week
  extraParams,
  filtersPayload,
  limit,
  extraPayload = {}
}) => {
  return await axios.post(
    urlV2(LINB_API.RESOURCE_ALLOCATION.WIDGETS.OVER_TIME_CHART),
    {
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      ...(type && { type }),
      ...(issue_type && { issue_type }),
      aggregation_ranges,
      ...(limit && { limit }),
      configure: {
        ...(extraParams && { ...extraParams })
      },
      ...(filtersPayload && { ...filtersPayload }),
      ...(extraPayload && { ...extraPayload })
    }
  );
};

export const getDonutChart = async ({
  sensor_authorization_id,
  before,
  after,
  type, // project | epic | issue_type | initiative,
  extraParams,
  filtersPayload,
  extraPayload = {},
  limit
}) => {
  return await axios.post(
    urlV2(LINB_API.RESOURCE_ALLOCATION.WIDGETS.DONUT_CHART),
    {
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      type,
      ...(limit ? { limit } : {}),
      configure: {
        ...(extraParams && { ...extraParams })
      },
      ...(filtersPayload && { ...filtersPayload }),
      ...(extraPayload && { ...extraPayload })
    }
  );
};

export const exportAggregatedTable = async ({
  sensor_authorization_id,
  before,
  after,
  type, // enum: project|epic
  extraParams,
  filtersPayload,
  sort_by,
  sort_dir,
  keyword = '',
  annual_cost,
  extraPayload = {},
  issue_type
}) => {
  return await axios.post(
    urlV2(LINB_API.RESOURCE_ALLOCATION.WIDGETS.AGGREGATED_TABLE_EXPORT),
    {
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      type,
      ...(issue_type && { issue_type }),
      ...(sort_by ? { sort_by } : {}),
      ...(sort_dir ? { sort_dir } : {}),
      ...(keyword.length > 0 ? { keyword } : {}),
      configure: {
        ...(extraParams && { ...extraParams }),
        ...(annual_cost && { annual_cost })
      },
      ...(filtersPayload && { ...filtersPayload }),
      ...(extraPayload && { ...extraPayload })
    }
  );
};

export const getInvestmentCarvingCategoryIssues = async ({
  sensor_authorization_id,
  before,
  after,
  category_key,
  limit,
  offset,
  sort_by,
  sort_dir,
  filtersPayload,
  extraPayload = {}
}) => {
  return await axios.post(`${API.INVESTMENT_CARVING_V2}/category-issues`, {
    sensor_authorization_id,
    before: formatDate(before),
    after: formatDate(after),
    category_key,
    limit,
    offset,
    ...(sort_by ? { sort_by } : {}),
    ...(sort_dir ? { sort_dir } : {}),
    ...(filtersPayload && { ...filtersPayload }),
    ...(extraPayload && { ...extraPayload })
  });
};
